import { Flower2, Brain, HandMetal, Leaf } from 'lucide-react';

const services = [
  {
    icon: Flower2,
    title: 'Yoga',
    desc: 'Práticas adaptadas a todos os níveis, do iniciante ao avançado. Encontra o teu ritmo e floresce.',
    tag: 'Físico & Espiritual',
  },
  {
    icon: Brain,
    title: 'Meditação',
    desc: 'Técnicas guiadas de mindfulness e respiração para aquietar a mente e cultivar a presença.',
    tag: 'Mente & Consciência',
  },
  {
    icon: HandMetal,
    title: 'Massagem Terapêutica',
    desc: 'Tratamentos personalizados que libertam a tensão acumulada e restauram o equilíbrio energético.',
    tag: 'Corpo & Terapia',
  },
  {
    icon: Leaf,
    title: 'Nutrição',
    desc: 'Consultoria nutricional holística que nutre o corpo de dentro para fora com sabedoria e leveza.',
    tag: 'Saúde & Vitalidade',
  },
];

export default function Services() {
  return (
    <section id="servicos" className="py-28 bg-cream">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-20 reveal">
          <p className="font-dm text-xs tracking-[0.4em] text-sage uppercase mb-4">O que oferecemos</p>
          <h2 className="font-playfair italic text-5xl font-light text-ink">Os Nossos Serviços</h2>
          <div className="w-12 h-px bg-sage mx-auto mt-6" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                className="service-card reveal bg-white/60 border border-beige/40 rounded-2xl p-8 flex flex-col gap-5 cursor-pointer"
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <div className="w-12 h-12 rounded-full bg-beige-light flex items-center justify-center">
                  <Icon size={22} className="text-sage" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-dm text-[10px] tracking-[0.3em] text-sage/70 uppercase mb-2">{s.tag}</p>
                  <h3 className="font-playfair text-xl font-medium text-ink mb-3">{s.title}</h3>
                  <p className="font-dm text-sm text-ink-light leading-relaxed">{s.desc}</p>
                </div>
                <div className="mt-auto">
                  <button className="font-dm text-xs text-sage hover:text-sage-dark transition-colors flex items-center gap-2 cursor-pointer group">
                    Saber mais
                    <span className="group-hover:translate-x-1 transition-transform">→</span>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
